'use client'
import supabaseClient from '@/lib/supabaseBrowser'

const SUPABASE_REF = 'tteyhdkjygsxuhhuyuxm'

/** Start Google login and return to /auth/callback with next + role. */
export async function startGoogleLogin(
  role: 'teacher' | 'student' = 'student',
  nextPath?: string,
  registrationCode?: string
) {
  const next = nextPath ?? (role === 'teacher' ? '/teacher' : '/student')
  const origin = window.location.origin
  const promoCode = String(registrationCode || '').trim().toUpperCase()
  const promoSuffix = promoCode
    ? `&promo=${encodeURIComponent(promoCode)}`
    : ''
  const redirectTo = `${origin}/auth/callback?next=${encodeURIComponent(next)}&role=${encodeURIComponent(role)}${promoSuffix}`

  // Nuke any stale PKCE verifiers before starting a new flow
  try {
    document.cookie = `sb-${SUPABASE_REF}-auth-token-code-verifier=; Max-Age=0; Path=/; SameSite=Lax`
    document.cookie = `sb-pkce-code-verifier=; Max-Age=0; Path=/; SameSite=Lax`
    window.localStorage.removeItem('sb-pkce-code-verifier')
  } catch {}

  const { error } = await supabaseClient().auth.signInWithOAuth({
    provider: 'google',
    options: { redirectTo },
  })
  if (error) throw error
}
